import React, { FC } from "react";
import Tooltip from "../../../../components/Tooltip/Tooltip";

import safeZoneIcon from "../../icons/safeZone.svg";
import styles from "./safeZone.module.scss";

type SafeZoneOverlayProps = {
  visible: boolean;
};

export const SafeZoneOverlay: FC<SafeZoneOverlayProps> = ({ visible }) =>
  visible ? <div className={styles.safeZoneOverlay} aria-hidden /> : null;

type SafeZoneButtonProps = {
  isVisible: boolean;
  onToggle: () => void;
};

export const SafeZoneButton: FC<SafeZoneButtonProps> = ({
  isVisible,
  onToggle,
}) => (
  <Tooltip
    text={isVisible ? "Hide safe zone" : "Show safe zone"}
    withoutTranslation
  >
    <button
      type="button"
      className={styles.safeZoneButton}
      onClick={onToggle}
      aria-label={isVisible ? "Hide safe zone" : "Show safe zone"}
    >
      <img
        src={safeZoneIcon}
        alt=""
        className={`${styles.safeZoneIcon} ${isVisible ? styles.safeZoneIconActive : ""}`}
      />
    </button>
  </Tooltip>
);
